<template>
  <div class="word-count-network" :class="wordCountClass">
    <span class="network-icon">
      <i :class="networkIconClass"></i>
    </span>
    <span class="total-words" v-html="captionLength"></span>
    <span class="words-divider">/</span>
    <span class="max-words">{{network.max_message_length}}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  components: {
    
  },
  props: ['network', 'caption'],
  computed: {
    wordCountClass(){
      let overMax = false;
      if (this.caption.length > this.network.max_message_length){
        overMax = true;
      }
      
      return {
        'over-max': overMax
      }
    },
    networkIconClass(){
      let iconClass = 'fab fa-'+this.network.api_type;
      let classObj = {}
      classObj[iconClass] = true;
      return classObj;
    },
    captionLength(){
      return this.caption.length;
    }
  },
  created(){

  }
}
</script>